function check_rules(channels) {
  const MIN_CHANNELS = 2
  const MIN_CHANNELS_RECOMMENDED = 4
  const RULES_LENGTH = 3
  const MAX_CHANNELS = 4

  const rules = {}

  rules.hasChannels = !!channels.length
  // Check Rules:
  rules.hasMobile = hasMobile(channels)
  rules.hasLengthMin = channels.length >= MIN_CHANNELS
  rules.hasLengthMinRecommended = channels.length >= MIN_CHANNELS_RECOMMENDED
  const validated_rules_length = [ rules.hasMobile, rules.hasLengthMin, rules.hasLengthMinRecommended ].filter(Boolean).length

  // Check hidden Rules for Errors:
  rules.hasUniquesInfo = hasUniquesInfo(channels)
  rules.hasLengthMax = channels.length <= MAX_CHANNELS

  // Check Status:
  const stepperStatus = () => {
    if (!rules.hasMobile || !rules.hasUniquesInfo || !rules.hasLengthMax ) {
      return 'danger'
    }
    return rules.hasLengthMinRecommended ? 'success' : 'warning'
  }

  rules.stepper = {
    steps: RULES_LENGTH,
    current: validated_rules_length,
    status: stepperStatus()
  }

  return rules
}

function hasMobile(channels) {
  return channels.some(channel => channel.type === 'mobile')    
}

function hasUniquesInfo(channels) {
  const allNames = channels.map(channel => channel.watchman.name)
  const allUniquesNames = Array.from(new Set(allNames))
  const allValues = channels.map(channel => channel.value)
  const allUniquesValues = Array.from(new Set(allValues))
  return allNames.length === allUniquesNames.length && allValues.length === allUniquesValues.length
}

export { check_rules, hasMobile }